import { MenuItemInfo } from './openapi_gen/deliveryProviderPortal/deliveryCampaignProvider/models';

// Todo This interface should be in a menu specific folder.
export interface MenuItemsUpdateInfo extends MenuItemInfo {
  price: number;
  currency: string;
}

// Todo This is sublist of PromotionFilterRules. It should be moved to a promotions specific folder.
export enum DiscountTarget {
  ALL_CUSTOMER = 'discount_targeting_all_customers',
  NEW_CUSTOMER = 'discount_targeting_new_customers',
  RETURNING_CUSTOMER = 'discount_targeting_returning_customers',
  CHURNED_CUSTOMER = 'discount_targeting_churned_customers',
  BEST_CUSTOMER = 'discount_targeting_best_customers',
}

// Todo This is a frontend-only interface. It should be moved to a promotions specific folder.
export interface PromotionCopyPrefillParams {
  preselect_by_trait?: string;
  from_campaign_log_id?: number;
  use_only_trade_event_promotions?: boolean;
  offer_id?: number;
}

// TODO This is a sublist of PromotionFilterRules. It should be moved to a promotions specific folder.
export enum TypeOfDiscount {
  FREE_DELIVERY = 'type_of_discount_free_delivery',
  FREE_BASE_DELIVERY = 'type_of_discount_free_base_delivery',
  FULL_MENU = 'type_of_discount_full_menu',
  DOUBLE_DEAL = 'type_of_discount_double_deal',
  SELECTED_ITEMS = 'type_of_discount_selected_items',
  TRADE_EVENT = 'type_of_discount_trade_event',
}
